module.exports = __webpack_public_path__ + "static/media/photostick-logo.9158a8d8.png";